define('services/auth/ticket',['require','exports','module'],function(require, exports, module) {
  "use strict";

  module.exports = function(config) {
    var get = function(callbackOk, callbackError, companyId) {
      const ajaxParams = {
        method: "get",
        dataType: "json",
        url: config.authHost + (companyId ? "?company_id=" + companyId : ""),
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        success: function(response) {
          if (callbackOk) {
            callbackOk(response);
          }
        },
        error: function(err) {
          if (callbackError) {
            callbackError(err);
          }
        }
      };
      $.ajax(ajaxParams);
    };
    return {
      get: get
    };
  };

});

